import { pick } from 'lodash';
import { cleanDefaultValuesURLSearchParams } from 'src/common/utils/urlSearchParamsUtils';
import { ESIM_INITIAL_FILTERS, ESimFilters } from 'src/products/esim/constants/esim';

export const mapESimFiltersToURLSearchParams = (esimFilters: ESimFilters) => {
  const cleanedFiltersValues = cleanDefaultValuesURLSearchParams(esimFilters, ESIM_INITIAL_FILTERS);
  return new URLSearchParams(cleanedFiltersValues);
};

export const mapURLSearchParamsToESimFilters = (urlSearchParams: URLSearchParams): ESimFilters => {
  const filters = Object.fromEntries(urlSearchParams);

  const cleanedFiltersValues = pick(filters, Object.keys(ESIM_INITIAL_FILTERS));

  return {
    ...ESIM_INITIAL_FILTERS,
    ...cleanedFiltersValues,
  };
};
